import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import styles from "../../../../SpecialtyPersonalStyles.module.scss"
import metadata from './ConstructionComponent.metadata.json5';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function ConstructionComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated, basePath } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('ConstructionComponent');

    const modelVM = _.get(submissionVM, pathUpdated);
    const baseModelVM = _.get(submissionVM, basePath);

    modelVM.value.isValidationReq = true;

    const setInitialValue = () => {
        const yearBuiltValue = _.get(modelVM, 'yeaBuiFie.value');
        if(yearBuiltValue && yearBuiltValue.length === 4 && _.get(baseModelVM, 'publicID.value') === undefined
            && _.get(modelVM, 'eleYealasupdFie.value') === undefined && _.get(modelVM, 'heaYealasupdFie.value') === undefined
             && _.get(modelVM, 'pluYealasupdFie.value') === undefined && _.get(modelVM, 'rooLasUpdFie.value') === undefined) {
                handleValueChange(yearBuiltValue,'eleYealasupdFie.value');
                handleValueChange(yearBuiltValue,'heaYealasupdFie.value');
                handleValueChange(yearBuiltValue,'pluYealasupdFie.value');
                handleValueChange(yearBuiltValue,'rooLasUpdFie.value');
        }

    }

    
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        othFie: {
            visible: _.get(modelVM, 'conFie.value.code') === 'Other'
        },
        ifothpleexpFie: {
            visible: _.get(modelVM, 'rooRooTypFie.value.code') === 'Other'
        },
        ifOthExpFie: {
            visible: _.get(modelVM, 'priHeaTypFie.value.code') === 'Other'
        },
        ifothpleexp2Fie: {
            visible: _.get(modelVM, 'priHeaFueTypFie.value.code') === 'Oth'
        },
        ifothfuetyppledesFie: {
            visible: _.get(modelVM, 'auxHeaFueTypFie.value.code') === 'Oth'
        },
        ifAppAnnCorofWooBuBurFie: {
            visible: _.get(modelVM, 'auxHeaFie.value.code') === 'ComwitWoo' || _.get(modelVM, 'priHeaTypFie.value.code') === 'ComwitWoo' ||
                    _.get(modelVM, 'priHeaFueTypFie.value.code') === 'Wood' || _.get(modelVM, 'auxHeaFueTypFie.value.code') === 'Wood'
        },
        ifAppAnnBagofPelBuBurFie: {
            visible: _.get(modelVM, 'auxHeaFie.value.code') === 'ComwitWoo' || _.get(modelVM, 'priHeaTypFie.value.code') === 'ComwitWoo' ||
                    _.get(modelVM, 'priHeaFueTypFie.value.code') === 'Wood' || _.get(modelVM, 'auxHeaFueTypFie.value.code') === 'Wood'
        },
        ifOthindnumofampFie: {
            visible: _.get(modelVM, 'howmanampistheelessysFie.value.code') === 'Other'
        },
        yeaBuiFie: {
            onBlur: setInitialValue
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

ConstructionComponent.propTypes = wizardProps;
export default withRouter(ConstructionComponent);
